import { UploadedBalanceReport } from '@src/pages/companyInformation/index';

const TGUploadedBalanceReports = () => {
  return <UploadedBalanceReport isMarket={true} />;
};

export default TGUploadedBalanceReports;
